// extracted by mini-css-extract-plugin
export default {"editModal":"_2vR72pyL","oneEducation":"_3lGiIs8N","updateCancel":"_32n0fmg2","btnUpdateCancel":"_2G3J1Ryi","warning":"_1wLn6U_P"};